import { Component, Inject, OnInit, LOCALE_ID } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  SEND_RESET_TOKEN_MUTATION,
  VERIFY_RESET_TOKEN_MUTATION,
  RESET_PASSWORD_MUTATION,
} from '@asp/graphql';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordValidators } from '@asp/validators';

type Token = {
  token: string;
  valid: boolean;
};

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnInit {
  sendEmailResult = undefined;
  resetPasswordResult = undefined;
  token: Token;

  readonly emailForm = new FormGroup({
    emailValue: new FormControl('', [Validators.required, Validators.email]),
  });

  readonly passwordForm = new FormGroup({
    passValue: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      PasswordValidators.passwordStrength,
      PasswordValidators.fieldMatch('repassValue', true),
    ]),
    repassValue: new FormControl('', [
      Validators.required,
      PasswordValidators.fieldMatch('passValue'),
    ]),
  });

  constructor(
    private apollo: Apollo,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(LOCALE_ID) public locale: string,
  ) {}

  ngOnInit() {
    const token = this.route.snapshot.paramMap.get('token');
    this.token = { token: token, valid: false };

    if (this.token.token) {
      this.verifyToken();
    }
  }

  sendToken() {
    this.apollo
      .mutate({
        mutation: SEND_RESET_TOKEN_MUTATION,
        variables: {
          email: this.emailForm.controls.emailValue.value,
          locale: this.locale,
        },
      })
      .subscribe(({ data }: any) => {
        if (data.sendResetToken) {
          this.sendEmailResult = true;
        }
      });
  }

  verifyToken() {
    this.apollo
      .mutate({
        mutation: VERIFY_RESET_TOKEN_MUTATION,
        variables: {
          token: this.token.token,
        },
      })
      .subscribe({
        next: ({ data }: any) => {
          if (data.verifyResetToken) {
            this.token.valid = true;
          }
        },
        error: () => {
          this.router.navigate(['/password-reset']);
        },
      });
  }

  resetPassword() {
    this.apollo
      .mutate({
        mutation: RESET_PASSWORD_MUTATION,
        variables: {
          token: this.token.token,
          newpassword: this.passwordForm.controls.passValue.value,
          locale: this.locale,
        },
      })
      .subscribe({
        next: ({ data }: any) => {
          if (data.resetPassword) {
            this.resetPasswordResult = true;
          }
        },
      });
  }
}
